"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateIntention = exports.StateMedium = exports.NotificationState = exports.UpdateTypesHumanized = exports.UpdateType = exports.UpdateState = exports.UpdateReferenceTypes = exports.UpdateGroupType = void 0;
var UpdateGroupType;
(function (UpdateGroupType) {
    UpdateGroupType["RKI"] = "183dfcde-76f8-4a87-8839-b61f3a8ba2be";
    UpdateGroupType["LegalProcess"] = "69294d0c-031e-4754-9688-ed02064c95a5";
    UpdateGroupType["ReminderProcess"] = "7a62726b-90d0-4615-9eb0-cfe0902f9c52";
    UpdateGroupType["CaseHandover"] = "7eab11d6-77d6-4741-ad15-7046c31594c1";
    UpdateGroupType["MonitoringProcess"] = "b3095ef3-5095-484c-91cf-15f47220def5";
    UpdateGroupType["EstateProcessing"] = "b39fb37c-8749-4d3a-a2f5-40436484628d";
    UpdateGroupType["DebtCollectionProcess"] = "f313f319-3395-4de1-958b-093b093d0015";
})(UpdateGroupType || (exports.UpdateGroupType = UpdateGroupType = {}));
var UpdateReferenceTypes;
(function (UpdateReferenceTypes) {
    UpdateReferenceTypes["CASE"] = "CASE";
    UpdateReferenceTypes["CREDITOR"] = "CREDITOR";
})(UpdateReferenceTypes || (exports.UpdateReferenceTypes = UpdateReferenceTypes = {}));
var UpdateState;
(function (UpdateState) {
    UpdateState["Executed"] = "EXECUTED";
    UpdateState["RolledBack"] = "ROLLED_BACK";
})(UpdateState || (exports.UpdateState = UpdateState = {}));
var UpdateType;
(function (UpdateType) {
    UpdateType["CreditorEndedCase"] = "508a08ce-e128-4ba2-9424-484efbdec775";
    UpdateType["Dead"] = "d5829622-ef58-4fea-a2c8-a998982c4d93";
    UpdateType["MovedAbroad"] = "9ff2c7f6-8a29-49b3-842e-f727a8ddcd89";
    UpdateType["Disappeared"] = "f1a1b30c-6f96-4c7d-b688-23bc6ffc49d6";
    UpdateType["Homeless"] = "5190e2de-9508-4373-b84a-e3a33cff719a";
    UpdateType["Inactive"] = "5d83ba53-7d28-40a8-9ff8-29292c0e1824";
    UpdateType["OperationsCeased"] = "ee8ecc2e-ff33-42f8-af47-2cbe2336c26d";
    UpdateType["GuardianStatus"] = "8b83c071-0737-4bd4-a810-6bc8388a54f9";
    UpdateType["DeletedRKIRegistration"] = "89f8b176-1a78-4181-ac14-55944fcbd43b";
    UpdateType["DeletedRKIRegistrationWillingnessToPay"] = "6cba3636-1b46-41b8-a716-46406007b480";
    UpdateType["NewRKIRegristration"] = "6e9eef80-f063-4b17-baf7-5f05170e0045";
    UpdateType["Address"] = "34818a81-b490-4e8f-ac69-be0f9db8fd81";
    UpdateType["AddressProtection"] = "9cc47392-cb24-451e-bd59-232cb6611859";
    UpdateType["RKIRemark"] = "fa8030a6-6aef-4fc1-95b3-4474ab1fd72c";
    UpdateType["Active"] = "70d6431c-1cb9-4db5-abdf-8e2aa630d495";
    UpdateType["CompanyActive"] = "61c2f61c-fa68-44d1-b742-e6ec71e4c983";
    UpdateType["DissolutionStatus"] = "b23027fa-863a-4b12-a073-a34596287238";
    UpdateType["DebtorIsUnderage"] = "62c32aa3-b274-40c5-91a4-34cd2934757e";
    UpdateType["AKSStatus"] = "02c18bc0-71b1-4f39-b797-e5e5f0e10347";
    UpdateType["AKSFailed"] = "c9d41b7e-13e7-44d3-8c82-0de637243e5d";
    UpdateType["AKSUpdateName"] = "3d0d0123-5c58-42ed-8311-31d8568a668b";
    UpdateType["AKSUpdateAddress"] = "6bee262f-4699-4a10-9e06-fac8f0a8bedc";
    UpdateType["AKSUpdateStatus"] = "3e136fb1-05aa-4c1c-9a8e-dbe151f965c0";
    UpdateType["AKSUpdateProtection"] = "2f95931c-d711-4deb-a8e2-2137f4a0d06f";
    UpdateType["AKSUpdateNewRKI"] = "29c2498e-cc52-4271-8c0b-97499f20350d";
    UpdateType["AKSUpdateDeletedRKI"] = "184cbbd5-87a3-4585-909b-13505bc3d059";
    UpdateType["AKSUpdateCreditWarning"] = "a1b0b42e-f2ed-4272-bfe8-1886786350fb";
    UpdateType["AKSUpdateAdvertisementPreference"] = "2661f58f-2d12-429f-a733-98a75906d2fe";
    UpdateType["AKSUpdateGuardianStatus"] = "6e57246d-2836-4f7c-97d6-84768df97957";
    UpdateType["AKSUpdateRKI"] = "61ff806b-fdf8-40fb-acae-b1dc8f2144eb";
    UpdateType["EXITREQUEST"] = "adbdf7d0-5866-408a-8dc1-fa9dff9b7ac7";
    UpdateType["CASESTATUSMOVE"] = "9d21a0d1-1f17-4e3c-b217-a3484464f5cb";
    UpdateType["SOP"] = "684c7861-3f94-401e-80c4-2e010cdefbb9";
    UpdateType["UPDATE"] = "ded7d020-0e8b-479c-bce4-078e70056c81";
    UpdateType["NOCONTACTINFORMATION"] = "3bb47ff7-7749-4970-87ec-5d5aaa731dab";
    UpdateType["DEPOSIT"] = "4ef604a8-8156-4801-b1ba-818edbb6bf88";
    UpdateType["NEWDEBT"] = "345f38ef-9ad5-4115-8d83-b72b8bd167d6";
    UpdateType["NEWINTERACTION"] = "5247f27c-075f-4b25-b984-dac7fa67e107";
    UpdateType["eBoksFailed"] = "e137eeab-7dfb-46f6-a1f6-d4710891f733";
    UpdateType["TECHNICALINVESTIGATION"] = "25114295-3363-4652-bc69-f45bc8aebb0d";
    UpdateType["TERMINATIONREQUEST"] = "5686fa4e-1f30-476d-b8ce-cc263bbda6c7";
    UpdateType["PENDINGTERMINATION"] = "e0891657-e2bd-4a2a-b624-1b6ee454f19d";
    UpdateType["CANCELTERMINATION"] = "e88f882f-9df4-465e-9bc2-27ca0df98297";
    UpdateType["CASECONTINUED"] = "7e2da982-f7c3-4800-bf17-80b7eb01042c";
    UpdateType["POSTPONECASEWORKING"] = "81740970-f8be-4b07-9cca-9cb625e03f36";
    UpdateType["RETURNLETTER"] = "c160f9e8-4e47-454c-a162-65835de46ec0";
    UpdateType["BOBEHANDLING"] = "fbd37e4f-3799-4bbc-9443-1985b3b65535";
    UpdateType["BOBEHANDLET"] = "42dbad03-073e-445e-b0a2-7132bb7387b0";
    UpdateType["AWAITINGSTAEVNING"] = "62ed7df9-8a8c-4a22-a4cf-c11d146a5c8b";
    UpdateType["AFDRAGSORDNINGER"] = "0a1443aa-937d-4262-8d31-d9c1ed189318";
    UpdateType["ApprovedByCreditor"] = "77f13a15-3a6c-48e3-83d3-56cdfdd42bbd";
    UpdateType["ApprovedByDatahub"] = "09ea5ad0-3a70-4daa-8d34-5bb09bb2d391";
    UpdateType["CancelApprovedByDatahub"] = "eff59dba-6e49-4fa9-b00a-1026601234ed";
    UpdateType["CancelRejectedByDatahub"] = "9d977532-c443-4e1c-a7fe-5c972924fafd";
    UpdateType["CancelRequestedBecauseOfPaymentToCreditor"] = "06631c38-a250-4cd2-8e5f-d95c4de50e87";
    UpdateType["RejectedByCreditor"] = "5197ff54-b961-40ed-bcf4-8781eb3c14aa";
    UpdateType["RejectedByDatahub"] = "eca05465-1416-4bd0-a4e9-de07f5cfd9d6";
    UpdateType["PAYMENTPLANINITIAL"] = "c6f11db1-3cb2-4d2d-9089-4552eb5aa827";
    UpdateType["NEWCLIENTINTERACTION"] = "19391617-05a3-4f67-8860-be1ca173a06e";
    UpdateType["NEWDEBTORINTERACTION"] = "6ebd981e-1f1d-4a92-baf0-3e8dec375b23";
    UpdateType["DEBTORPERSONALDATAREQUEST"] = "4ca4ef13-b16c-4638-88a6-a128329f7920";
    UpdateType["AWAITINGCLIENTANSWER"] = "11f6ac74-0d08-46a3-ba91-7139ae6c8923";
    UpdateType["DEFAULTEDPAYMENTPLAN"] = "5e7c16ba-f9a4-4cd2-bd6b-7113300b8e0c";
    UpdateType["OVERPAYPAYMENTPLAN"] = "2225d832-8466-49bb-9816-1cb8ce466c25";
    UpdateType["RKIDenied"] = "7c716d90-9bc7-4eda-8fb2-49621a0f1c29";
    UpdateType["RKIApproved"] = "7e509ec0-780a-4223-89b5-70d5aebed763";
    UpdateType["RKIApprovalRequest"] = "98be8abe-6c33-4349-af89-f636e2594e24";
    UpdateType["NoCourtSubmit"] = "b0a84718-cce2-4190-899e-89a757e61083";
    UpdateType["YesCourtSubmit"] = "7725e1d3-5e18-49ae-bb2d-25751ef8c077";
    UpdateType["NotSureCourtSubmit"] = "a49c6124-fb23-4976-8400-9afd9018bc85";
    UpdateType["RKIREGISTRATION"] = "237dbc4b-705d-46f5-995a-78bd519b3b5c";
    UpdateType["RKISTATUS"] = "c1a14a06-2806-4d1d-9302-0ba4514e91ac";
    UpdateType["OPPOSITION"] = "33d8c425-988f-4385-a2e4-1fdc69da6107";
    UpdateType["NOTOPPOSITION"] = "8c347bc0-c7ac-4a89-a202-b75906eb749d";
    UpdateType["FSNUMMER"] = "0d9d29b7-e0ef-4289-a7cb-3ba8577a3228";
    UpdateType["RKIAPPROVEDBYCLIENT"] = "033e8880-bfc5-4a4e-8fd2-ae44ed7b9af1";
    UpdateType["REQUESTCLIENTRKI"] = "21cfbb48-a135-4ef2-af83-d6b87bfe5f63";
    UpdateType["REMOVEFROMRKI"] = "73535e4d-1147-4a09-8917-8805c6e86e58";
    UpdateType["AUTOREMOVEFROMRKI"] = "2a4ff063-05cf-41dd-825b-1cee95c73c13";
    UpdateType["DOCSIGNED"] = "5b0b9929-12c9-4da7-8a1f-4898c433cdcb";
    UpdateType["COSMOSUBSCRIBED"] = "261b81c2-24c6-4d63-81a1-0a3eaf0ae422";
    UpdateType["COSMOUNSUBSCRIBED"] = "8fbec7f8-3ace-4a22-9a6b-d2f917d01624";
    UpdateType["AWAITINGFOGEDREKVISITION"] = "d86e2f45-9be9-4ab5-a528-144d8a954219";
    UpdateType["ISINFOGEDRETTEN"] = "db10769f-e994-423b-9c7f-a84f85a33dbe";
    UpdateType["ISINCIVILCOURT"] = "05ffe8b5-9e35-4358-99d9-a450387f4147";
    UpdateType["PAYMENTONCASEINCOURT"] = "d6e6eca0-9bea-4c75-8d55-f000980b0e9a";
    UpdateType["RECEIVEDCOURTFOUNDATION"] = "e08dfecb-e62a-4bd8-a1f8-b3fe8d617c5d";
    UpdateType["POLITIFREMSTILLING"] = "6baa45ff-1dfc-46a0-9bae-4020866b77b2";
    UpdateType["DECIDECOURT"] = "e23bd860-4111-4a91-aa77-e5a4b98dffab";
    UpdateType["AWAITINGPOWERTERMINATION"] = "12601180-92c6-4a33-a5c6-711f7c97c885";
    UpdateType["TERMINATEDCUSTOMER"] = "d17fdf9e-4e6c-4138-a545-ccbf4cf72520";
    UpdateType["FOGEDREVISITIONCLIENTREQUEST"] = "9036d745-349c-40a0-b54e-ca5d718962d0";
    UpdateType["TICKETRESOLVED"] = "a8c4f745-8e5b-4686-9111-5e02d06296ac";
    UpdateType["MIGRATIONNOTE"] = "29ad3ea7-7b92-4ab9-b144-dc3950462089";
    UpdateType["TILJURIDISKBEHANDLING"] = "ef9105f2-e7fa-4a12-a250-c1405a209045";
    UpdateType["COURTEVENTS"] = "ef9dda79-f9e0-46c4-b10e-68278fa092f2";
    UpdateType["AFTEROFFICEHOURS"] = "b821c950-cf74-448b-8ee0-23201d921ddb";
    UpdateType["AWAITINGPAYMENTAFTERCONCILIATION"] = "662a1385-cb72-4bec-bf9c-fee85dadda15";
    UpdateType["PHONEMEETING"] = "55024f1f-ecf4-4cba-a9c6-a4bb93fc3dbb";
    UpdateType["INSOLVENS"] = "7cfa4b4b-dc42-408b-85be-80d0f4aac74f";
    UpdateType["DEBTEXPIRESWITHINTHREEMONTHS"] = "a0248e2b-bcbf-42a9-ae8c-22225f252bed";
    UpdateType["DEBTWITHFOUNDATIONEXPIRESWITHINTHREEMONTHS"] = "e9a45ef3-1c6f-4096-8bd4-7a8512e15360";
    UpdateType["DEBTEXPIRED"] = "c1053b85-74d5-49f0-9fb4-b2064ae2a8cb";
    UpdateType["EMAILFAILED"] = "19c8ebaf-6a2d-4dcf-95f6-94f3030c89ab";
    UpdateType["AWAITINGCIVILCOURT"] = "bbd7df7e-ca31-447a-bd30-c8be42d61ff0";
    UpdateType["AWAITINGFINALSTATEMENT"] = "3fb1a59d-1de4-435c-bc7f-7c938f9d7640";
    UpdateType["MIGRATEDJOURNALNUMBER"] = "cbffe6c7-10cd-4aa1-a656-0e465ecaa544";
    UpdateType["RKIREGISTRATIONOPEN"] = "96f2d62b-488a-490c-8aab-896d107be446";
    UpdateType["RKIREGISTRATIONCLOSED"] = "23c9a11f-07ab-48bf-af64-ae65b00116ee";
    UpdateType["AUTORKIREGISTRATIONOPEN"] = "b895bd09-719d-4737-b38a-c015d594860f";
    UpdateType["AUTORKIREGISTRATIONCLOSED"] = "63ce57c2-a228-4ef1-b48e-e07fdb480a9f";
    UpdateType["RKIWARNED"] = "89da9a4c-b9c4-47f0-9289-45738d169945";
    UpdateType["BPKWARNED"] = "9c578a99-ae26-4ec8-9eab-6e3faef16d6a";
    UpdateType["STAEVNINGREQUSTCLIENT"] = "14dc07fa-6391-4795-b0f9-955dfc7b5eda";
    UpdateType["NEWCOURTINTERACTION"] = "24cc1058-635d-4f72-9158-8859392fa08b";
    UpdateType["REMINDER"] = "3300ee95-8309-4c46-b56b-45381f66b10c";
    UpdateType["OUTBOUNDCALL"] = "32f1b501-4e80-451e-a615-5e1232a98ee4";
    UpdateType["UDLAEG"] = "04128f9a-4f41-437e-b515-703147f14b92";
    UpdateType["UDLAEGCIVIL"] = "10485680-06aa-4ff2-b207-bae743c9aec1";
    UpdateType["UDLAEGAFLYSES"] = "1614341c-e793-4945-8e47-06745e5d4aeb";
    UpdateType["OVERDRAGESTILINKASSOPARTNER"] = "4b585ec5-07da-4e37-9322-e34142b695b1";
    UpdateType["WRITTREQUEST"] = "e8496ddc-8b18-4e5b-b3bd-6af0f563f37d";
    UpdateType["AWAITWRITTPAYMENT"] = "55f204fc-0729-464a-90c0-a679a995c859";
    UpdateType["AWAITINGPARTNER"] = "1da49f7e-5f3c-4cf9-a7cd-512b31fb2c7f";
    UpdateType["UNIDENTIFIED"] = "72c6ef39-18bc-4ea4-90fa-639094a9f210";
    UpdateType["COURTREMINDER"] = "834e74f5-5952-480f-b12e-83d6b67531b2";
    UpdateType["DEPARTED"] = "aae6af91-df2e-4483-9047-6df90c114b7b";
    UpdateType["DECIDECONTINUE"] = "b364293b-c9ab-4506-b1d1-ccb2949cf401";
    UpdateType["PAYMENTPLANCANCLED"] = "6f58533c-61ef-4b61-b09a-6b3d8ac398a6";
    UpdateType["INTERNALREMARK"] = "d6954ba3-4677-4e2c-b32b-a7f1df7b2a3d";
    UpdateType["MOVETOOPENRKI"] = "57611225-599c-4314-abf0-df26d662f2ed";
    UpdateType["PAYMENTREVOKED"] = "063e7e09-9903-422c-9793-454ac1c9c9da";
    UpdateType["SentToConnectPartner"] = "972f1179-41e2-4509-a620-1cef6d245108";
    UpdateType["ReturnedToConnectPartner"] = "254a307f-2971-4182-91e8-4066475c8cde";
    UpdateType["DebtorCanBeRegisteredInDebtRegister"] = "07f28db9-1803-4808-953b-8be69375e68f";
    UpdateType["CaseMergedTo"] = "e86cce3c-959c-4e95-a8c7-346cef63a4c6";
    UpdateType["CaseMergedFrom"] = "569ec9a5-eb7f-4131-924b-94396f5bde5e";
})(UpdateType || (exports.UpdateType = UpdateType = {}));
exports.UpdateTypesHumanized = {
    [UpdateType.FSNUMMER]: ['FS-nummer'],
    [UpdateType.INSOLVENS]: ['Insolvens'],
    [UpdateType.RECEIVEDCOURTFOUNDATION]: ['Modtaget dom'],
    [UpdateType.AFDRAGSORDNINGER]: ['Afdragsordninger'],
    [UpdateType.AWAITINGFOGEDREKVISITION]: ['Afventer fogedrekvisition'],
    [UpdateType.AWAITINGPARTNER]: ['Afventer samarbejdspartner'],
    [UpdateType.OPPOSITION]: ['Indsigelse'],
    [UpdateType.POLITIFREMSTILLING]: ['Politifremstilling'],
    [UpdateType.UNIDENTIFIED]: ['Uidentificérbar'],
    [UpdateType.NEWDEBTORINTERACTION]: ['Ny debitorinteraktion'],
    [UpdateType.AWAITINGCLIENTANSWER]: ['Afventer svar fra klient'],
    [UpdateType.BOBEHANDLING]: ['Bobehandling'],
    [UpdateType.NotSureCourtSubmit]: ['Afventer indlevering af betalingspåkrav'],
    [UpdateType.ISINFOGEDRETTEN]: ['Er i fogedretten'],
    [UpdateType.RKIREGISTRATION]: ['RKI-registrering'],
    [UpdateType.AWAITINGCIVILCOURT]: ['Afventer civilretten'],
    [UpdateType.ISINCIVILCOURT]: ['Er i civilretten'],
    [UpdateType.OVERDRAGESTILINKASSOPARTNER]: [
        'Overdrages til ekstern inkassopartner',
    ],
    [UpdateType.POSTPONECASEWORKING]: ['Udskyd sagsbehandling'],
    [UpdateType.DECIDECOURT]: ['Vurdér eventuelle retslige skridt'],
};
var NotificationState;
(function (NotificationState) {
    NotificationState["UNSEEN"] = "UNSEEN";
    NotificationState["SEEN"] = "SEEN";
    NotificationState["DISMISSED"] = "DISMISSED";
})(NotificationState || (exports.NotificationState = NotificationState = {}));
var StateMedium;
(function (StateMedium) {
    StateMedium["WEB"] = "WEB";
    StateMedium["EMAIL"] = "EMAIL";
})(StateMedium || (exports.StateMedium = StateMedium = {}));
var UpdateIntention;
(function (UpdateIntention) {
    UpdateIntention["DebtExpired"] = "DEBT_EXPIRED";
    UpdateIntention["DebtExpiresWithinThreeMonths"] = "DEBT_EXPIRES_WITHIN_THREE_MONTHS";
    UpdateIntention["DebtExpiresWithinThreeMonthsWithFoundation"] = "DEBT_WITH_FOUNDATION_EXPIRES_WITHIN_THREE_MONTHS";
    UpdateIntention["DebtorCanBeRegisteredInDebtRegister"] = "DEBTOR_CAN_BE_REGISTERED_IN_DEBT_REGISTER";
})(UpdateIntention || (exports.UpdateIntention = UpdateIntention = {}));
//# sourceMappingURL=index.js.map